module.exports = __webpack_public_path__ + "media/images/flaechenvorhaenge-b4ea6a99301e2707bb6e34c28bc6536d.jpg";